export default __webpack_public_path__ + "static/whitepaper-covid-19-feature1-f3db31fde2e83660a14d77924492a204.png";